// extracted by mini-css-extract-plugin
module.exports = {"title":"InfoBlock-module--title--OH5HP","text":"InfoBlock-module--text--1T2pP"};